import React, { Component } from 'react';
import PropTypes from 'prop-types';
import defaultImg  from '../../../assets/images/news.png';

class NewsSectionItem extends Component {
    constructor(props) {
        super(props);
        this.props = props;
    }

    setDefaultImg = (e) => {
        e.target.src = defaultImg;
    }

    createMarkupTextPreview = () => {
        const removeTags = this.props.news.textPreview.replace(/(\<(\/?[^>]+)>)/g, '');
        const cutNews = removeTags.slice(0, 147) + '...';
        const news = removeTags.length >= 150 ? cutNews : removeTags;
        return {__html: news};
    }
   
    render() {
        let image = <img onError={this.setDefaultImg} src={`/api/welsend/public/news/${this.props.news.newsId}/file`} 
                                         className="news-image" alt={`img_${this.props.news.newsId}`} referrerPolicy="no-referrer"/>;
        return (
         <div className='item-news'>
            {image}
            <div>
                <div className='title'>{this.props.news.name}</div>
                <div className='textPreview' dangerouslySetInnerHTML={this.createMarkupTextPreview()}>
                </div>
            </div>
         </div>
        )
    }
}

export default NewsSectionItem;

NewsSectionItem.propTypes = {
    news: PropTypes.object.isRequired,
}